import { subscriptionKeys } from '../../../lib/query/subscriptionKeys';

// Billing query-key factory (P18 §4). Re-exports the shared
// `subscriptionKeys` (`lib/query/subscriptionKeys.ts`) under this module's
// own names rather than declaring a second, competing literal — the module
// does not own this cache namespace outright (it's read across module
// boundaries: Sidebar, Dashboard, the public PricingPage), so the shared file
// is the one source of truth; see its own header comment for why it lives
// there and not here (story 2-73 — this was the hand-rolled outlier the
// sweep closed: before this, every call site outside this module wrote the
// literal `['subscription', orgId]` inline instead of importing a factory,
// which is exactly the drift that split 2-32/2-54's 404 fix out of sync).
export const billingKeys = {
  all: ['billing'] as const,
  subscription: subscriptionKeys.detail,
  plans: subscriptionKeys.plans,
};
